export default {
	data() {
		return {
			rules: {
				notEmpty: v => (v !== null && String(v).trim() !== '') || this.$i18n.t('text.errorEmpty'),
				email: v => /[ßäöüÄÖÜa-zA-Z0-9._%+-]+@[ßäöüÄÖÜa-zA-Z0-9.-]+\.[a-zA-Z]{2,9}/.test(v) || this.$i18n.t('text.errorInvalidEmail'),
				isTime: v => /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/.test(v) || this.$i18n.t('text.errorInvalidInput'),
				validStartEnd: (v) => {
					if (v == null || v == '') return true;
					const end = this.$moment(this.endDate);
					const start = this.$moment(this.startDate);
					return (end.isValid() && start.isValid() && end >= start) || this.$i18n.t('text.errorEndBeforeStart');
				},
				maxLen6: v => (v == null || v.length <= 6) || this.$i18n.t('text.toLong'),
				maxLen20: v => (v == null || v.length <= 20) || this.$i18n.t('text.toLong'),
				maxLen30: v => (v == null || v.length <= 30) || this.$i18n.t('text.toLong'),
				maxLen200: v => (v == null || v.length <= 200) || this.$i18n.t('text.toLong'),
				min1: v => (v == null || v >= 0) || this.$i18n.t('text.errorMinOne'),
				max12: v => (v == null || v <= 12) || this.$i18n.t('text.errorMax12'),
				max31: v => (v == null || v <= 31) || this.$i18n.t('text.errorMax31'),
			},
		};
	},
};
